import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import artwalkMap from "../../assets/artwalk-map-final.jpg";

import "./styles.scss";

const variants = {
  open: {
    opacity: 0.9,
    x: 0,
    position: "fixed",
    backgroundColor: "#097b87",
    zIndex: 100,
    height: "100%",
    top: 0,
    overflowY: "auto",
    boxShadow: "3px 3px 3px rgba(0,0,0, .2 )",
    maxWidth: 1000,
  },
  closed: {
    opacity: 0,
    x: "-100%",
    position: "absolute",
    height: "100%",
    top: 0,
  },
};

function SideDrawer(props) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(props.show);
  }, [props.show]);

  function scrollTo(element) {
    const id = document.getElementById(element);
    id.scrollIntoView({ behavior: "smooth" });
  }

  // Build Links

  const links = [
    "art-walk-1",
    "art-walk-2",
    "art-walk-3",
    "art-walk-4",
    "art-walk-5",
    "art-walk-6",
    "art-walk-7",
    "art-walk-8",
    "art-walk-9",
    "art-walk-10",
    "art-walk-11",
    "art-walk-12",
  ];

  const navigation = links.map((item, index) => {
    return (
      <li className="tw-m-1 tw-inline-block">
        <button
          onClick={() => {
            scrollTo(item);
            props.change();
          }}
          className="tw-font-extrabold font-slab tw-inline-block tw-transition tw-duration-300 tw-ease-in-out hover:tw-scale-110 tw-justify-center tw-font-bold tw-items-center tw-block tw-w-8 tw-h-8 tw-text-center tw-rounded-full  tw-bg-tertiary hover:tw-bg-secondary tw-drop-shadow-md"
        >
          {index + 1}
        </button>
      </li>
    );
  });

  return (
    <>
      <motion.div
        animate={isOpen ? "open" : "closed"}
        variants={variants}
        initial="closed"
      >
        <div className="tw-overflow-y-visbible tw-h-[100%] tw-d-flex">
          <div className="tw-relative">
            <div className="tw-flex">
              <button
                onClick={() => props.change()}
                className="tw-absolute tw-t-0 tw-left-[20px] tw-w-[20px] tw-h-[20px] tw-top-[-40px] tw-end-[20px]"
              >
                <XMarkIcon className="tw-h-6 tw-w-6 tw-bg-primary tw-cursor-pointer tw-top-10 tw-absolute tw-italic tw-block tw-font-bold  tw-max-w-xs tw-transition tw-duration-300 tw-ease-in-out hover:tw-scale-110" />
              </button>
              <div>
                <div>
                  <img src={artwalkMap} />
                  <div className="tw-flex tw-justify-center tw-p-4">
                    <div>
                      <div className="tw-grid tw-grid-cols-2 tw-mt-2 tw-mb-5 tw-rounded-lg tw-bg-[#388993] tw-p-4">
                        <div className="tw-flex tw-justify-center">
                          <ul>
                            <li className="tw-mb-2 tw-list-none tw-flex tw-align-middle tw-rounded-full">
                              <div className="tw-h-6 tw-w-6 tw-bg-routepurple tw-flex tw-justify-center tw-align-middle font-slab tw-font-extrabold tw-mr-2 tw-rounded-full">
                                1
                              </div>
                              Art Walk Stop
                            </li>
                            <li className="tw-list-none tw-flex">
                              <div className="tw-h-6 tw-w- tw-mr-2 bg-contruction tw-w-[30px]"></div>
                              Construction
                            </li>
                          </ul>
                        </div>
                        <div className="tw-flex tw-justify-center">
                          <ul>
                            <li className="tw-mb-2 tw-list-none tw-flex">
                              <div className="tw-bg-white tw-p-1 tw-rounded-sm tw-mr-2">
                                <ArrowRightIcon className="tw-h-4 tw-w-4 tw-text-routeblue" />
                              </div>
                              Route
                            </li>
                            <li className="tw-list-none tw-flex">
                              <div className="tw-bg-white tw-p-1 tw-rounded-sm tw-mr-2">
                                <ArrowRightIcon className="tw-h-4 tw-w-4 tw-text-routegreen" />
                              </div>
                              ADA Route
                            </li>
                          </ul>
                        </div>
                      </div>
                      <ul>{navigation}</ul>
                      <p className="tw-italic tw-text-sm tw-font-bold tw-mb-4 tw-text-center  tw-pt-2">
                        Tap or click a number to navigate to an Art Walk Stop
                      </p>
                    </div>
                  </div>
                </div>
                <div className="tw-p-4 md:tw-w-[80%]">
                  <h1 className="tw-text-6xl lg:tw-text-[4.0rem] lg:tw-leading-[4rem] xl:tw-text-[3.0rem] xl:tw-leading-[2.75rem] tw-font-bold tw-mb-4">
                    HSC
                    <br />
                    Wellness
                    <br />
                    Art <span className="tw-italic">Walk</span>
                  </h1>
                  <p className="tw-text-sm  tw-mb-4">
                    Join us on a one mile walking excursion featuring art
                    installations across UNM's North Campus. Through this
                    interactive Lobo Trail, you'll get a chance to stretch your
                    legs, breathe fresh air and scan QR Codes at each stop to
                    learn more about specific artworks on our campus.
                  </p>
                  <p className="tw-text-sm tw-font-bold tw-mb-4">
                    ADA Route from 9 to 10: Please take elevator in Domenici
                    Center for Health Sciences Education (Bldg. 200) to floor
                    "B" to exit Happy Heart Bistro on the lower level
                  </p>
                  <p className="tw-text-sm tw-font-bold tw-mb-4">
                    Due to construction, this path may change unexpectedly
                  </p>

                  <div className="tw-relative tw-pb-8">
                    <span
                      onClick={() => props.change()}
                      className="tw-w[20px] tw-h-[20px] tw-t[0] tw-r[10px] tw-cursor-pointer  tw-absolute tw-italic tw-block tw-font-bold  tw-max-w-xs tw-transition tw-duration-300 tw-ease-in-out hover:tw-scale-110"
                    >
                      close map
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
}
export default SideDrawer;
